import {
  ApiListRequest,
  ApiListResponse,
  FacilityDTO,
  FacilityStatus,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["memberApiFacility"] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
};

export const memberApiFacility = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params: {
        status?: FacilityStatus;
        id?: number[];
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<FacilityDTO>>(`/customer/facility`, {
              params: { ...params, page: pageParam },
            })
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
